"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var data = require("./data");
function characterize(text) {
    var e_1, _a, text_1, text_1_1, char, e_1_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, 6, 7]);
                text_1 = __values(text), text_1_1 = text_1.next();
                _b.label = 1;
            case 1:
                if (!!text_1_1.done) return [3 /*break*/, 4];
                char = text_1_1.value;
                return [4 /*yield*/, character(char)];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                text_1_1 = text_1.next();
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 7];
            case 5:
                e_1_1 = _b.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 7];
            case 6:
                try {
                    if (text_1_1 && !text_1_1.done && (_a = text_1.return)) _a.call(text_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
exports.characterize = characterize;
function character(char) {
    return Object.freeze({
        type: characterType(char),
        char: char,
    });
}
exports.character = character;
function characterType(char) {
    if (data.closingGroupingRegex.test(char))
        return 'closing_grouping';
    if (data.closingQuoteRegex.test(char))
        return 'closing_quote';
    if (data.decimalDigitRegex.test(char))
        return 'decimal_digit';
    if (data.horizontalSpaceRegex.test(char))
        return 'horizontal_space';
    if (data.nameContinueRegex.test(char))
        return 'name_continue';
    if (data.nameStartRegex.test(char))
        return 'name_start';
    if (data.openingGroupingRegex.test(char))
        return 'opening_grouping';
    if (data.openingQuoteRegex.test(char))
        return 'opening_quote';
    if (data.punctuationRegex.test(char))
        return 'punctuation';
    if (data.togglingQuoteRegex.test(char))
        return 'toggling_quote';
    if (data.verticalSpaceRegex.test(char))
        return 'vertical_space';
    return 'unclassified';
}
exports.characterType = characterType;
